import { render, staticRenderFns } from "./chargingStandard.vue?vue&type=template&id=0d2b6686"
import script from "./chargingStandard.vue?vue&type=script&lang=js"
export * from "./chargingStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports